const pagesProfileAppIdRuleAndPolicyEn = {
  badge: {
    exclusive: 'Exclusive',
    multiple: 'Multiple',
    ordered: 'Ordered'
  },
  common: {
    action: {
      add: 'Add',
      cancel: 'Cancel',
      edit: 'Edit',
      invalidCustomRule: 'There are conditions that are not set correctly in the rule',
      newRule: 'New Rule',
      noCustomRule: 'no rule set',
      noCustomRuleTitle: 'Name not specified',
      save: 'Save',
      savedCustomFilter: 'Saved Custom Rule',
      successfulMessage: '🎉 Saved successfully! After a few moments, the rule will be reflected in the list of accounts'
    },
    group: {
      extraMembers: 'Extra members',
      memberCount: '{{count}} members',
      missingMembers: 'Missing members',
      noViolation: 'No violations',
      title: 'Groups',
      violationCount: '{{count}} violations'
    },
    individual: {
      exclude: 'Exclude',
      excludeNone: '-',
      include: 'Include',
      includeNone: '-',
      inclusionPeriod: 'Period',
      inclusionProvenanceLink: 'View issuance operation',
      inclusionPurpose: 'Purpose'
    },
    infoMessage: {
      description: 'Rules are applied in order from the role with the strongest authority. Accounts assigned to higher roles are not eligible for assignment under the rules for lower roles.'
    },
    licenseSheet: 'License Sheet',
    loadError: 'Failed to load rules. Please reload the page.',
    noPeopleGroupAssigned: 'No PeopleGroup is assigned to this license.',
    settingType: {
      ALL: 'Assign to all',
      CUSTOM: 'Custom Rule',
      CUSTOM_NEST: 'Custom Rule(Nested)',
      NO_ONE: 'Assign to no one'
    },
    settingTypeForTop: {
      ALL: 'All',
      CUSTOM: '-',
      CUSTOM_NEST: '-',
      NO_ONE: '-'
    },
    subGroup: {
      disabled: 'Disabled',
      memberCount: '{{count}} members',
      noSubGroups: 'No sub-groups configured',
      syncNotCompleted: 'Sync not completed',
      tabLabel: 'Sub-Group',
      violatedSubGroup: 'Profile change required',
      violationCount: '{{count}} violations',
      workerCount: '{{count}} workers'
    },
    tableLoadError: 'Failed to load the table. Please reload the page.',
    tableOfContent: {
      title: 'Assignment rules'
    },
    workerType: {
      // TODO: common.workerType に統一したい
      BOARD_MEMBER: 'Board',
      COLLABORATOR: 'Collaborator',
      CONTRACTOR: 'Contractor',
      EMPLOYEE: 'Employee'
    }
  },
  components: {
    commandLineUserGuidance: {
      addCondition: 'Add condition',
      select: 'Select',
      title: 'Add condition for person'
    },
    conditionCommandLine: {
      noResultsFound: 'No results found',
      placeholder: 'Search person attributes...',
      placeholderForInt: 'Enter a number...'
    },
    customRuleExpression: {
      addCondition: 'Add condition',
      addConditionGroup: 'Add condition group'
    }
  },
  pageTitle: '{{name}} - Rule&Policy',
  sideTab: {
    accounts: 'Accounts',
    assignmentRules: 'Assignment Rules',
    closeSideTab: 'Close side tab',
    groups: 'Groups',
    licenses: 'Licenses'
  },
  table: {
    accountRole: 'Account role',
    group: 'Group',
    license: 'License',
    order: 'Order',
    searchByGroup: 'Search by group...',
    searchByLicense: 'Search by license...',
    searchByRole: 'Search by account role...',
    total: 'Total'
  }
};
export default pagesProfileAppIdRuleAndPolicyEn;